'use strict';
const _ = require("lodash");
const $ = require("jquery");
const Backbone = require("backbone");
const PubSub = require('./../PubSub');

// views and models
const ViewError = require('./../views/error');
const ViewLoading = require('./../views/loading');
const ViewHome = require('./../views/home');
const ViewCategory = require('./../views/category');
const ViewConfirm = require('./../views/confirm');
const ViewModal = require('./../views/modal');
const ViewAuth = require('./../views/auth');
const ViewVideo = require('./../views/video');
const ViewThanks = require('./../views/thanks');
const ViewSocial = require('./../views/social');
const ViewLiveVote = require('./../views/live-vote');
const ModelBase = require('./../models/base');
const ViewSweeps = require('./../views/sweeps');
const ViewGlobalBanner = require('./../views/global-banner');
const ViewUpsell = require('./../views/upsell');
const PollView = require('./../views/poll');

// util functions
const getScrollY = require( '../util/scroll-position' );

module.exports = Backbone.Router.extend({
    controller: null,
    currentView: null,
    currentModal: null,
    routes: {
        ''                    : 'category',
        'auth'                : 'auth',
        'error/:name'         : 'error',
        'loading/:name'       : 'loading',
        'thanks'              : 'thanks',
        'sweeps'              : 'sweeps',
        'poll'                : 'poll',
        ':category'           : 'category',
        'video/:id'           : 'video'
    },
    _windowDimensions: {},
    history: [],
    openCategories: [],
    openPositions: [],
    indexPage: false,
    /**
     *
     */
    initialize: function (options) {
        if (_.isUndefined(options)) return;

        // https://jira.telescope.tv/browse/MMA-352
        // https://stackoverflow.com/questions/7035331/prevent-automatic-browser-scroll-on-refresh
        $(window).on('beforeunload', function(e) {
            var $elAttr = $(document.activeElement).attr('href');
            if($elAttr && $elAttr.indexOf('mailto') > -1) return;
            $(window).scrollTop(0);
        });

        if((("ontouchstart" in document.documentElement) || ("ontouchstart" in window))) $('body').attr('ontouchstart', '');

        this.route = options.route || "-1";
        this.isInitialized = true;
        this.winnerPageViewFired = false;
        this.appRoot = options.appRoot || '/';

        this.controller = options.controller;
        this.instanceID = $(options.el || document.body).attr('id');
        this.uid = options.uid;
        this.uniqueId = this.uid + "_" + Math.round(Math.random() * 1000000);

        this.lastTrackedPage = null;
        this.transitionAnimation = parseInt(this.controller.Models.Cms.get('text').customization.transition_time) || 500;
        this.registerListeners();

        this.$body = $(options.el || document.body);
        this.$modalScope = $(options.modal || this.$body);

        this.$modal = $('<div class="modal"'+(   (_.isEqual(options.container, options.modal)? '' : ' id="'+options.uid+'Modal"' )   )+' />');
        this.$modalScope.append(this.$modal);

        this.renderPage();

        this.listenTo( this.controller.Models.Cms, 'change:appState', this.renderPage );
    },
    /**
     * [registerListeners description]
     * @return {[type]} [description]
     */
    registerListeners: function() {

        this.listenTo(PubSub, '_back', this._back.bind(this));
        this.listenTo(PubSub, 'loadVideo', this.video.bind(this));
        this.listenTo(PubSub, 'modalConfirm', this.confirm.bind(this));

        this.listenTo(PubSub, 'navigate', function(route, options) {
            options = options || {trigger: true};
            if(this.route == route || options.isCategory) {
                const uri = '/' + route.replace('/', '').toLowerCase();
                this.navigate(uri, { trigger: false });
                this.category(route.replace('/', ''), options.hideAnimation);
            } else {
                this.navigate(route, options);
            }
        }.bind(this));

        this.listenTo(PubSub, 'directRoute', function(route, options) {
            if(_.isUndefined(options)) options = null;
            this[route](options);
        }.bind(this));

        this.listenTo(PubSub, 'openFirstCategory', function() {
            var categoryToOpen = this.controller.Collections.Categories.findWhere({ active: '1' });
            var categoryHeader = this.$app.find('.category-button[data-category-id='+categoryToOpen.get('id')+']');
            categoryHeader.addClass('active');

            // open the category with the scroll animation to the top of the category
            PubSub.trigger('navigate', categoryToOpen.get('displayName'), { isCategory: true, trigger: true });

            // open the category without the scroll animation to the top of the category
            // this.category(categoryToOpen.get('displayName'), true);
        }.bind(this));

        // Event Listener to hide individual categories
        // For window view and open view, when a user directly clicks the category to hide
        this.listenTo(PubSub, 'hideCategory', function(model, $category) {
            var categoryView = _.findWhere(this.openCategories, {model: model});
            // in the instance that categoryView returns undefined, find the category by displayName
            if(!categoryView) {
                categoryView = _.findWhere(this.openCategories, {id: model.get('displayName')});
            }

            var position = this.openCategories.indexOf(categoryView);
            var destroyHTML = this.openPositions[position];

            if(categoryView) {
                categoryView.$el.animate({
                    height: 0
                }, this.transitionAnimation, function() {

                    // remove the class "active" only after the closing animation
                    if($category && $category.hasClass('active')) {
                        $category.removeClass('active');
                    }

                    categoryView.remove();
                    categoryView = null;
                    this.openCategories.splice(position, 1);
                    destroyHTML.html(null);
                    this.openPositions.splice(position, 1);

                    $(window).trigger('resize.unveil');
                }.bind(this));
            }
        }.bind(this));

        this.listenTo(PubSub, 'openSocialCategory', function() {
            var categoryToOpen = this.controller.Collections.Categories.findSocialCategory();
            PubSub.trigger('closeAllCategories', categoryToOpen.get('displayName'), categoryToOpen.get('id'));
        }.bind(this));

        this.listenTo(PubSub, 'openAllCategories', function(initialized) {

            this._openAllCategoriesCalled = true;

            _.forEach(this.controller.Collections.Professional.models, function(model, index) {
                var view = new ViewCategory({
                    model: model,
                    turbo: this.controller.Models.TurboVoteProperty,
                    user: this.controller.Models.Auth,
                    dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                    copy: this.controller.Models.Cms.get('text').view_grid,
                    cms: this.controller.Models.Cms,
                    css: this.controller.Models.Cms.get('text')['customization']['css'],
                    uid: this.uid,
                    hideAnimation: true
                });

                var index = parseInt(model.get('id'));
                this.setCurrentView(view, index, true);
            }.bind(this));

            _.forEach(this.controller.Collections.Categories.models, function(model, index) {
                var view = new ViewCategory({
                    model: model,
                    user: this.controller.Models.Auth,
                    dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                    copy: this.controller.Models.Cms.get('text').view_grid,
                    cms: this.controller.Models.Cms,
                    css: this.controller.Models.Cms.get('text')['customization']['css'],
                    uid: this.uid,
                    hideAnimation: true
                });

                var index = parseInt(model.get('id'));

                this.setCurrentView(view, index, true);

                this._isOpen('/');
    
            }.bind(this));

            if(initialized) this.isInitialized = true;
        }.bind(this));

        this.listenTo(PubSub, 'closeAllCategories', this.closeAllCategories.bind(this));

        this.listenTo(PubSub, 'openUpsell', this.openUpsell.bind(this));

        this.mtvAdCreated = false;

        this.on('route', this._saveHistory.bind(this));
        $(window).on('scroll', this._handleScroll.bind( this ));
        $(window).on('resize', this._handleResize.bind( this ));
    },
    /**
     * Login modal - only shows up when a user clicks on the plus button for a contestant
     */
    auth: function (selectedCategory) {
        var data = this.controller.Models.Cms.get('text')['view_auth'];

        // save the selected category to see if we need to increase votes after log in
        this.controller.selectedCategory = selectedCategory;

        var view = new ViewAuth({
            model: data,
            css: this.controller.Models.Cms.get('text')['customization']['css'],
            uid: this.uid,
            native: this.controller.nativeApp,
            google: this.controller.Models.GoogleLogin,
            facebook: this.controller.Models.Facebook
        });

        this.setCurrentModal(view);
        this.isInitialized = false;
    },
    /**
     *
     */
    category: function (category, hideAnimation) {
        if ( this._openAllCategoriesCalled ) {
            this.isInitialized = false;
            this._openAllCategoriesCalled = false;
            return;
        }

        var initialCategoryNotFound = false;

        if(!this._isOpen(category)) return;

        var initialAnimation = !(_.isNull(category) && this.controller.Models.Cms.get('appState') === 'winner');

        if(this.isInitialized) {
            category = this.route.replace("/", "");
        }

        var model = this.controller.Collections.Professional.findCategoryByDisplayName(category) || this.controller.Collections.Categories.findCategoryByDisplayName(category);
        // in the instance there is no hash route on initialization,
        // we default to the first category in the collection
        if(_.isUndefined(model)) {
            model = this.controller.Collections.Categories.findWhere(function(category) {
                return category.get('active') === '1' && category.get('voteData').length > 0;
            }) || this.controller.Collections.Categories.models[0];

            initialCategoryNotFound = true;
        }

        if( model.get('voteData').length === 0 ) {
            return;
        }

        // upon initialization, the grid view will not have the active style
        // applied to it, we will need to add it accordingly
        if(this.isInitialized && model) {
            var categoryHeader = this.$app.find('.category-button[data-category-id='+model.id+']');

            categoryHeader.addClass('active');

            // if we are in the winnners state, the grid view will handle all the opening and closing of the categories
        } else if(this.controller.Models.Cms.get('appState') == 'winners') {
            return;
        }

        if(hideAnimation) {
            initialCategoryNotFound = true;
        }

        // undefined for model.get('social') if the category JSON has not been updated
        // this is to prevent it from loading the incorrect view
        var view;

        // check if we need to increment a contestant vote after a user logs in
        var contestantToIncrementID = null;
        if(this.controller.selectedCategory && (this.controller.selectedCategory.categoryID === model.id)) {
            contestantToIncrementID = this.controller.selectedCategory.contestantID;
        }
        this.controller.selectedCategory = null;

        if((model.get('social') == '0' || model.get('social') == undefined) && model.get('live_vote') == '0') {
            view = new ViewCategory({
                model: model,
                user: this.controller.Models.Auth,
                dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                copy: this.controller.Models.Cms.get('text').view_grid,
                cms: this.controller.Models.Cms,
                css: this.controller.Models.Cms.get('text')['customization']['css'],
                uid: this.uid,
                hideAnimation: initialCategoryNotFound,
                initialAnimation: initialAnimation,
                contestantToIncrementID: contestantToIncrementID
            });
        } else if(model.get('live_vote') == '0') {
            var socialId = model.get('social');
            var socialKey = 'social_'
            var copy = this.controller.Models.Cms.get('text').view_social_category[socialKey + socialId];

            var copy = new ModelBase({
                copy: copy,
                uid: this.uniqueId
            }, {
                textKey: 'view_social_category',
                cms: this.controller.Models.Cms
            });

            view = new ViewSocial({
                model: model,
                user: this.controller.Models.Auth,
                dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                copy: copy,
                cms: this.controller.Models.Cms,
                css: this.controller.Models.Cms.get('text')['customization']['css'],
                uid: this.uid,
                hideAnimation: initialCategoryNotFound
            });

        } else {
            var copy = new ModelBase({
                copy: this.controller.Models.Cms.get('text').view_live_vote_category,
                uid: this.uniqueId
            }, {
                textKey: 'view_live_vote_category',
                cms: this.controller.Models.Cms
            });

            view = new ViewLiveVote({
                model: model,
                user: this.controller.Models.Auth,
                dimensions: this.controller.Models.Cms.get('text').customization.contestant_images,
                copy: copy,
                cms: this.controller.Models.Cms,
                css: this.controller.Models.Cms.get('text')['customization']['css'],
                uid: this.uid,
                hideAnimation: initialCategoryNotFound
            });

        }

        var index = parseInt(model.get('id'));

        this.controller.pageName = model.get('displayName');

        if (initialCategoryNotFound && (this.controller.pageName !== category)) {
            const uri = '/' + model.get('displayName').replace('/', '').toLowerCase();
            this.navigate(uri, { trigger: false });
        }

        this.setCurrentView(view, index);
    },
    /**
     * Close all the open categories
     * @param viewToOpen - name of the view to navigate to
     * @param viewID - reference to the view to be opened
     * @param callback - callback function
     */
    closeAllCategories: function(viewToOpen, viewID, callback, hideAnimation) {

        if(this.openCategories.length === 0) {
        if(viewToOpen) PubSub.trigger('navigate', viewToOpen);
        else if(typeof callback === 'function') callback();
        return;
        }

        var ctr = 0;
        var totalOpenCategories = this.openCategories.length;

        this.openCategories.forEach(function(value) {

        var position = this.openCategories.indexOf(value);
        var destroyHTML = this.openPositions[position];

        value.$el.animate({ height: 0 }, 250, function() {

            ctr++;
            value.remove();
            value = null;

            this.openCategories.splice(position, 1);
            destroyHTML.html(null);
            this.openPositions.splice(position, 1);

            if(totalOpenCategories === ctr && viewToOpen) {
            PubSub.trigger('navigate', viewToOpen, { isCategory: true, trigger: true, hideAnimation: hideAnimation });
            } else if(totalOpenCategories === ctr && typeof callback == 'function') {
            callback();
            }

        }.bind(this));
        }.bind(this));
    },
    /**
     * Confirmation modal that prompts the user with the following options:
     * Submit - this submits the votes for the category
     * Edit - this closes the modal and lets the user make changes to votes
     */
    confirm: function(category) {
        if(category.get('hasAlreadyConfirmed')) return;

        var view = new ViewConfirm({
            copy: this.controller.Models.Cms.get('text').view_confirmation,
            model: category
        });
        this.setCurrentModal(view);

        category.set('hasAlreadyConfirmed', true);
    },
    /**
     *
     */
    closeCurrentModal: function () {
        this.closedCurrentModal();
    },
    /**
     *
     */
    closedCurrentModal: function () {
        if (this.currentModal !== null) {

            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
            this.$modalScope.alterClass('modal-has-*', '');
            this.$modalScope.removeClass('no-scroll');
            this.$modalScope.css('top', '');
            window.scrollTo(0, this.currentScroll || 0);
        }
    },
    /**
     *
     */
    error: function (name) {
        var data = this.controller.Models.Cms.get('text')['views_error'][name];
        data = (_.isObject(data) ? data : this.controller.Models.Cms.get('text')['views_error']['generic']);

        var view = new ViewError({
            model: data,
            name: name
        });

        this.setCurrentModal(view);
        this.isInitialized = false;
    },
    /**
     *
     */
    loading: function (name, requestedFragment) {
        var data = this.controller.Models.Cms.get('text')['views_loading'][name];
        data = (_.isObject(data) ? data : this.controller.Models.Cms.get('text')['views_loading']['generic']);

        var view = new ViewLoading({
            model: data,
            controller: this.controller,
            route: requestedFragment
        });

        this.setCurrentModal(view);
    },

    /**
     * renderPage
     */
    renderPage: function( model, val ) {
        // remove checkmarks when transitioning to winner state
        if (val && val === 'winner') return;
        // we only rerender from closed to open - page load is allowed
        if ( val && val !== 'open' ) return;

        _.forEach(this.openCategories, function( view ) { view.remove(); });

        // reset references to category views
        this.openCategories = [];
        this.openPositions = [];

        // remove current view
        this.currentView && this.currentView.remove();

        // remove page if it exists
        this.page && this.page.remove();

        this.initGlobalBanner();

        this.page = new ViewHome({
            model: {
                header: this.controller.Models.Header,
                footer: this.controller.Models.Footer,
                progress: this.controller.Models.Progress,
                grid: this.controller.Models.Grid,
                timer: this.controller.Models.Timer,
                timerClosed: this.controller.Models.TimerClosed,
                turbo: this.controller.Models.TurboVoteProperty
            },
            cms: this.controller.Models.Cms,
            uid: this.uid,
            native: this.controller.nativeApp
        });

        this.page.render();
        this.$app = this.page.$el;
        this.$body.html(this.page.$el);
        this.$body.addClass(this.uniqueID);
        this.page.renderedToDom();
    },

    initGlobalBanner: function() {
        const data = window.MTVBanner;
        if(data) {
            this.globalBanner = new ViewGlobalBanner({
                model: {
                copy: data.copy,
                promoResourceLinks: data.promoResourceLinks,
                upSellExit: data.parameters? data.parameters.upSellExit : false
                }
            });
            this.globalBanner.render();
            
            $('#global-banner').html(this.globalBanner.$el);
        }
    },

    openUpsell: function() {

        const data = window.MTVUpSell;
        if(data) {
        const backgroundImageData = data.images.find(image => image.imageUsageType === 'background');
        const showLogoData = data.images.find(image => image.imageUsageType === 'show_logo');

        const view = new ViewUpsell({
            model: {
            backgroundImage: backgroundImageData,
            copy: data.copy,
            headerText: data.headerText,
            promoResourceLinks: data.promoResourceLinks,
            showLogo: showLogoData,
            subheaderText: data.subheaderText
            }
        });
        this.setCurrentModal(view, true);
        this.isInitialized = false;
        }
    },
    /**
     *
     */
    setCurrentModal: function (view, alternate) {
        var modalContext = 'modal-has-' + view.className;

        var modal = new ViewModal({
            model: {view: view}, controller: this.controller
        });

        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
        }

        this.currentScroll = window.pageYOffset;
        this.$modalScope.alterClass('modal-has-*', modalContext);
        this.$modalScope.addClass('no-scroll');
        this.$modalScope.css('top', -(this.currentScroll) + 'px');

        this.$modal.html(modal.render().$el);

        // target specific modals
        modal.$el.find( '.modal-content' ).addClass( view.className.replace( 'view-', 'style-' ));
        if(view.className === 'view-video') {
            modal.$el.find( '.modal-content' ).addClass('fade-in');
        }

        if(alternate) {
            this.$modal.find('.view-modal').addClass('alternate');
        } else {
            this.$modal.find('.view-modal').removeClass('alternate');
        }

        // store current modal
        this.currentModal = this.controller.Views.Modal = modal;

        if(typeof this.currentModal.model.view.renderedToDom === 'function' ){
            this.currentModal.model.view.renderedToDom();
        }

        if(/(sweeps)/.test(view.className) || /(thanks)/.test(view.className)) {
            var pageName = (/(sweeps)/.test(view.className) ? 'Sweeps Modal' : 'Thanks Modal');

            var googleParams = {
                eventCategory: 'Page View',
                eventAction: pageName,
                eventLabel: pageName + ' : ' + this.controller.device
            };

            var omnitureParams = {
                page: pageName,
                url: window.location.href
            }

            PubSub.trigger('pageView', omnitureParams, googleParams);
        }
    },
    /**
     *
     */
    setCurrentView: function (view, index, initialWindowClosed) {        
        const isWinner = this.controller.Models.Cms.get('appState') === 'winner';
        // on windowClosed views, this.$app is undefined initially
        // set it here so the application can fully build
        if(initialWindowClosed) {
            this.$app = this.page.$el;
        } else {
            // garbage clean up in the instance that the category remains in the
            // openCategories and openPositions arrays
            var categoryOpen = _.findWhere(this.openCategories, {id: view.model.get('displayName')});

            if(categoryOpen && !categoryOpen.model) {
                // console.warn('currentView already exists, remove the view and reopen!!!');

                var position = this.openCategories.indexOf(categoryOpen);
                var destroyHTML = this.openPositions[position];

                categoryOpen.remove();
                this.openCategories.splice(position, 1);

                destroyHTML.html(null);
                this.openPositions.splice(position, 1);
            }
        }

        if(this.currentView == view) {
            return;
        }
        this.closeCurrentModal();

        var bodyContext = 'body-' + view.className;
        this.$body.alterClass('body-*', bodyContext);

        var elementToRender = this.$app.find('.grid-container[data-category-id='+index+']');
        // var elementToRender = this.$app.find('.grid-container')[parseInt(index) - 1];

        if(!(this.$app.find('.category-button[data-category-id='+index+']')).hasClass('toggle-animations')
        && this.controller.Models.Cms.get('appState') === 'winner') {
            view.initialAnimation = false;
        }; // MMA-352

        // store current view
        this.currentView = view;

        $(elementToRender).html(this.currentView.render().$el);

        this.currentView.id = this.currentView.model.get('displayName');
        this.route = this.currentView.id;

        if(typeof this.currentView.renderedToDom === 'function' ){
            this.currentView.renderedToDom();
        }

        this.openCategories.push(this.currentView);
        this.openPositions.push($(elementToRender));

        var pageName = this.currentView.model.get('name');

        if( isWinner && !this.winnerPageViewFired ) {
            var omnitureParams = {
                page: 'winner-page',
                url: window.location.href
            }

            PubSub.trigger('pageView', omnitureParams);  
            this.winnerPageViewFired = true;
        } else if( !isWinner && index !== undefined && !_.isUndefined(pageName) && initialWindowClosed !== true) {
            var omnitureParams = {
                page: pageName,
                url: window.location.href
            }

            if(this.lastTrackedPage !== pageName) {
                PubSub.trigger('pageView', omnitureParams);

                this.lastTrackedPage = pageName;
            }
        }

        // commented out this portion as we are on standby for
        // SEO updates, uncomment when ready to go!
        this._updateMetaData(initialWindowClosed);

        this.isInitialized = false;

        // used for lazy load to display the images on the page
        $(window).scroll();
    },
    /**
     *
     */
    setupMTVHeaderAd: function() {
        if( this.mtvAdCreated ) return;

        var windowWidth = $(window).width();
        var windowHeight = $(window).scrollTop();
        var mtvHeader = document.getElementById('header').scrollHeight;

        if(windowHeight <= mtvHeader) {
            if(windowWidth > 728) {
                this.controller.Models.Ad.createAd('skybox_leader_plus_sticky');
            } else {
                this.controller.Models.Ad.createAd('mobile_skybox_plus_sticky');
            }
            this.mtvAdCreated = true;
        }
    },
    /**
     *
     */
    sweeps: function () {
        var user = this.controller.Models.Auth.get('share');
        var thanks = this.controller.Models.Cms.get('text')['view_thanks']
        var copy = this.controller.Models.Cms.get('text')['view_sweepstakes'];

        var model = {
            user: user,
            copy: copy,
            native: this.controller.nativeApp,
            thanks: thanks
        };

        var view = new ViewSweeps({
            model: model,
            uid: this.uid,
            shareModel: this.controller.Models.Share,
            shareUrl: this.controller.Data.shareUrl
        });

        this.setCurrentModal(view, true);
        this.isInitialized = false;
    },
    /**
     *
     */
    poll: function () {
        var config = this.controller.Models.Cms.get('text')['view_poll'];

        var view = new PollView({
            uid: this.uid,
            userModel: this.controller.Models.Auth,
            pollWidgetId: config.poll_wid,
            getContextData: this.controller.getContextData.bind(this.controller),
            getUserData: this.controller.getUserData.bind(this.controller),
        });

        this.setCurrentModal(view, true);
        this.isInitialized = false;
    },
    /**
     *
     */
    thanks: function () {
        var user = this.controller.Models.Auth.get('share');
        var copy = this.controller.Models.Cms.get('text')['view_thanks'];

        var model = {
            user: user,
            copy: copy,
            native: this.controller.nativeApp
        };

        var view = new ViewThanks({
            model: model,
            css: this.controller.Models.Cms.get('text')['view_thanks']['customization'],
            uid: this.uid,
            shareModel: this.controller.Models.Share,
            shareUrl: this.controller.Data.shareUrl
        });

        this.setCurrentModal(view, true);
        this.isInitialized = false;
    },
    /**
     *
     */
    video: function(model, category) {
        var view = new ViewVideo({
            model: model,
            category: category
        });

        this.setCurrentModal(view, true);
    },
    /**
     * [window description]
     * @param  {[type]} category [description]
     * @return {[type]}          [description]
     */
    window: function() {
    },
    /**
     *
     */
    _back: function () {
        this.history.shift();
        var previous = this.history[0];
        this[previous.route](previous.params);
    },
    /**
     * _debouncedHandleScroll
     */
    _debouncedHandleScroll: _.debounce(function() {
        this.setupMTVHeaderAd();
    }, 500),
    /**
     * _debouncedHandleResize
     */
    _debouncedHandleResize: _.debounce(function() {
        this.setupMTVHeaderAd();
    }, 500),
    /**
     * _handleScroll
     */
    _handleScroll: function(e) {
        const nav = document.getElementById('mtv-mobile-menu');
        const header = document.getElementById('header');

        if( window.scrollY >= nav.offsetTop ) {
            header.classList.add('sticky');
        } else if( window.scrollY < nav.offsetTop) {
            header.classList.remove('sticky');
        }

        var scrollPos = getScrollY();
        this._debouncedHandleScroll();
        PubSub.trigger('window:scroll', scrollPos);
    },
    /**
     * _handleResize
     */
    _handleResize: function() {
        PubSub.trigger('window:resize');
        this._debouncedHandleResize();
    },
    /**
     *
     */
    _isOpen: function (requestedFragment) {
        // 1. If we are in one of the allowed regions, AND the window
        //    is open, immedately return true.  In all other cases,
        //    return false.
        // 2. If the region data has not returned yet, CHANGE the url
        //    to show loading, then once the region is available, CHANGE
        //    the url back to what it was at the time of the call
        // 3. If the region data has returned, but is not valid, CHANGE
        //    the url show out-of-geo
        // 4. If the region data has returned and is good, but the window
        //    is not open, CHANGE the url to the closed window page
        if(requestedFragment) {
            this.requestedFragment = requestedFragment;
        }

        // is the user out of the geographically acceptable region
        if (_.isNull(this.controller.Models.Geo.get('inRegion'))) {
            this.controller.Models.Geo.once('change:inRegion', function () {
                this.navigate(requestedFragment, {trigger: true});
            }.bind(this));
            // direct navigate to loading view without storing in browser history
            this.loading('generic', requestedFragment);
            // this.navigate('loading/generic', {trigger: true});
            return false;
        } else if (!this.controller.Models.Geo.get('inRegion')) {
            PubSub.trigger('directRoute', 'error', 'geo');
            return false;
        }

        // NOTES: This version of the MTV VMAs does not have a true window closed state
        // as users are able to open and close categories. The grid view and category views handle
        // the window closed view so we no longer need to route directly to the window closed view
        // IF MTV changes how the window closed view will look, this will need to be updated

        // is the window closed?
        // if(parseInt(this.controller.Models.Cms.get('settings').window_status, 10) === 0){
        //     this.window();
        //     return false;
        // }

        return true;
    },
    /**
     *
     */
    _modifyDisplayName: function(displayName) {
        var arrayName = displayName.split('-');
        var modifiedName = "";

        _.forEach(arrayName, function(name, index) {
            if(index == 0) {
                modifiedName = name.charAt(0).toUpperCase() + name.slice(1);
            } else {
                modifiedName = modifiedName + " " + name.charAt(0).toUpperCase() + name.slice(1);
            }
        });

        return modifiedName;
    },
    /**
     *
     */
    _saveHistory: function(route, params){
        this.history.unshift({
            route: route,
            params: params
        });
    },
    /**
     *
     */
    _updateMetaData: function(initialWindowClosed) {
        if(initialWindowClosed) return;

        var displayName = this.currentView.model.get('name');
        var metaData = this.controller.Models.Cms.get('text').customization.meta_data.deep_link;

        var description = metaData.description.replace('{{LINK}}', displayName);
        var title = metaData.title.replace('{{LINK}}', displayName);

        // update the document title
        document.title = title;

        $('meta[name=description]').attr('content', description);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/routes/router.js